var BaseView = require('../sticker/stickersall');

module.exports = BaseView.extend({

  where: { isPlaceholder: true },
  idPrefix: 'placeholder'

});
